var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-cover-view',_vm._g({attrs:{"scroll-top":_vm.scrollTop}},_vm.$listeners),[_c('div',{ref:"content",staticClass:"uni-cover-view"},[_vm._t("default")],2)])}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }